export const NEGOTIATION_LIST_REQUEST = "NEGOTIATION_LIST_REQUEST";
export const NEGOTIATION_LIST_SUCCESS = "NEGOTIATION_LIST_SUCCESS";
export const NEGOTIATION_LIST_FAIL = "NEGOTIATION_LIST_FAIL";

export const NEGOTIATION_ATTEMPT_DELETE_REQUEST = "NEGOTIATION_ATTEMPT_DELETE_REQUEST";
export const NEGOTIATION_ATTEMPT_DELETE_SUCCESS = "NEGOTIATION_ATTEMPT_DELETE_SUCCESS";
export const NEGOTIATION_ATTEMPT_DELETE_FAIL = "NEGOTIATION_ATTEMPT_DELETE_FAIL";